import { useContext } from 'react';

import { IntlContext } from '../providers/IntlProvider';

export const useLocale = () => {
  const context = useContext(IntlContext);
  if (!context) {
    throw new Error('useLocale must be used within IntlProvider');
  }
  return context;
};
